import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';

/**
 * A full-height framed pane for split-layout pages (user management, customers, …). Mirrors the
 * invoices list framing: a card that fills its grid/flex track rather than letting the page grow a
 * scrollbar. Pass `scroll` for a pane whose whole body should scroll (a detail view) — it wraps the
 * content in the styled `ScrollArea`. Omit it for a pane that owns its scroll region internally (e.g. a
 * search box pinned above a `ScrollArea`-wrapped list); the caller then supplies its own `ScrollArea`.
 */
export function FramedPane({
  children,
  className,
  scroll = false,
}: {
  children: ReactNode;
  className?: string;
  scroll?: boolean;
}) {
  return (
    <Card className="min-h-0 min-w-0">
      <CardContent className={cn('flex min-h-0 flex-1 flex-col', className)}>
        {scroll ? (
          <ScrollArea className="min-h-0 flex-1">
            {children}
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
